import Prop from './prop';

/**
 * Merge two objects.
 *
 *     new Extend({ a: 'hello' }, { a: 'goodbye', b: 'world'}).merge();
 *     // Result:
 *     // { a: 'hello', b: 'world' }
 *
 *     new Extend({ user: { id: null, name: 'John' }}, { user: { id: 1 }}).merge();
 *     // Result:
 *     // { user: { id: 1, name: 'John'}}
 *
 * @param {Object} target
 * @param {Object} source
 * @param {Boolean} deep
 */

export default class Extend {
  constructor(target, source, deep) {
    this.target = target;
    this.source = source;
    this.deep = deep;
  }

  /**
   *  @return {Object}
   */
  merge() {
    const prop = new Prop()
    for (let key in this.source) { //jshint ignore:line
      if (this.deep && (prop.isObj(this.target[key]) && prop.isObj(this.source[key]))) {
        this.target[key] = new Extend(this.target[key], this.source[key], this.deep).merge();
      } else {
        this.target[key] = this.source[key];
      }
    }

    return this.target;
  }
}
